import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAllClients,
  createClient,
  updateClient,
  deleteClient,
} from "../../services/clientService";

export const fetchClients = createAsyncThunk(
  "client/fetchClients",
  async ({ page = 1, limit = 10 }, thunkAPI) => {
    try {
      const data = await getAllClients(page, limit);
      console.log(data.data.data);
      return data.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const addClient = createAsyncThunk(
  "client/addClient",
  async (clientData, thunkAPI) => {
    try {
      console.log(clientData);
      const data = await createClient(clientData);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const editClient = createAsyncThunk(
  "client/editClient",
  async ({ id, clientData }, thunkAPI) => {
    try {
      const data = await updateClient(id, clientData);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const removeClient = createAsyncThunk(
  "client/removeClient",
  async (id, thunkAPI) => {
    try {
      await deleteClient(id);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  clients: [],
  total: 0,
  totalPages: 1,
  currentPage: 1,
  loading: false,
  error: null,
};

const clientSlice = createSlice({
  name: "client",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchClients.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchClients.fulfilled, (state, action) => {
        state.loading = false;
        state.clients = action.payload.items || [];
        state.total = action.payload.totalItems || 0;
        state.currentPage = action.payload.currentPage || 1;
        state.totalPages = action.payload.totalPages || 1;
      })

      .addCase(fetchClients.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add
      .addCase(addClient.fulfilled, (state, action) => {
        state.clients.unshift(action.payload);
      })

      // Edit
      .addCase(editClient.fulfilled, (state, action) => {
        state.clients = state.clients.map((client) =>
          client.id === action.payload.id ? action.payload : client
        );
      })

      // Delete
      .addCase(removeClient.fulfilled, (state, action) => {
        state.clients = state.clients.filter(
          (client) => client.id !== action.payload
        );
      });
  },
});

export default clientSlice.reducer;
